// Libs
import React from 'react'
import ReactDOM from 'react-dom'
import thunk from 'redux-thunk'
import { Provider } from 'react-redux'
import axios from 'axios'
import { polyfill } from 'smoothscroll-polyfill'

// CSS
import './styles/main.scss'

// Root
import Root from './root'

// Actions
import { changeAuth, reloadUser } from './containers/Auth/actions'

// Store
import store from './store'

// Env
import env from './env'

// Get token from local storage
const token = localStorage.getItem('token');
// If there's a token
if (token) {
  // Update application state before every render
  store.dispatch(changeAuth(true))
  store.dispatch(reloadUser(true))
}
// console.log(store.getState())

// Call smoothscroll polyfill
polyfill()

// Create instance server-node
export let serverAPI = axios.create({
  headers: {
    'X-Auth-Token': token,
    'authentication': '4uX39A8n@W#3Xk43zLy=a=9RY#37P@@cxacUdF-yLSWADwEDKG=guq4EcBC&4k-VmWBmUmU?_J2XkGmP*L8Ek4pM#bmPCb$4hxD2B8asWY9eRJeB$+tqEvE#zpnk^7+h',
    'userid': store.getState().auth.user.id,
    'groupid': store.getState().auth.user.groupId
  }
});

export let reportAPI = axios.create({
  headers: {
    'X-Auth-Token': token,
    'authentication': '4uX39A8n@W#3Xk43zLy=a=9RY#37P@@cxacUdF-yLSWADwEDKG=guq4EcBC&4k-VmWBmUmU?_J2XkGmP*L8Ek4pM#bmPCb$4hxD2B8asWY9eRJeB$+tqEvE#zpnk^7+h',
    'userid': store.getState().auth.user.id,
    'groupid': store.getState().auth.user.groupId,
    'content-type': 'application/json'
  }
})

export let searchAPI = axios.create({
  headers: {
    'X-Auth-Token': token,
    'authentication': '4uX39A8n@W#3Xk43zLy=a=9RY#37P@@cxacUdF-yLSWADwEDKG=guq4EcBC&4k-VmWBmUmU?_J2XkGmP*L8Ek4pM#bmPCb$4hxD2B8asWY9eRJeB$+tqEvE#zpnk^7+h',
    'userid': store.getState().auth.user.id,
    'groupid': store.getState().auth.user.groupId
  }
})


// Set default headers for request
// axios.defaults.headers.common['X-Auth-Token'] = token
// axios.defaults.headers.common['authentication'] = '4uX39A8n@W#3Xk43zLy=a=9RY#37P@@cxacUdF-yLSWADwEDKG=guq4EcBC&4k-VmWBmUmU?_J2XkGmP*L8Ek4pM#bmPCb$4hxD2B8asWY9eRJeB$+tqEvE#zpnk^7+h'
// axios.defaults.headers.common['userid'] = store.getState().auth.user.id
// axios.defaults.headers.common['groupid'] = store.getState().auth.user.groupId

// If is in development
if (env === 'production') {
  serverAPI.defaults.baseURL = 'https://server.semprocesso.com.br'
  reportAPI.defaults.baseURL = 'https://report-sql.semprocesso.com.br'
  searchAPI.defaults.baseURL = 'https://search.semprocesso.com.br'
  axios.defaults.baseURL = 'https://spbe.semprocesso.com.br'

} else {
  serverAPI.defaults.baseURL = 'http://localhost:3001'
  // serverAPI.defaults.baseURL = 'http://192.168.2.107:3001'
  // serverAPI.defaults.baseURL = 'https://server.semprocesso.com.br'
  reportAPI.defaults.baseURL = 'https://report-sql.semprocesso.com.br'
  // reportAPI.defaults.baseURL = 'http://localhost:3003'
  searchAPI.defaults.baseURL = 'https://search.semprocesso.com.br'
  // axios.defaults.baseURL = 'http://localhost:8080'
  axios.defaults.baseURL = 'https://spbe.semprocesso.com.br'
}

// Render the application
ReactDOM.render(
  // Provide the store to the whole app
  <Provider store={store}>
    <Root />
  </Provider>
  , document.getElementById('root'))
